import React, { useEffect } from 'react';
import AutomaticDrawer from 'components/Drawers/AutomaticDrawer';
import ninjaApi from 'store/redux/apis';
import { snackbar } from 'components/notifications/notifications';
import {
  useCreateConversionRuleMutation,
  useUpdateConversionRuleMutation,
} from 'store/redux/apis/conversion-rules.api';
import useQueryParams from 'hooks/useQueryParams';
import ConversionRuleForm from 'components/ConversionRule/ConversionRuleForm';
import * as yup from 'yup';

const PostbacksConversionRulesDrawer = (props) => {
  const { searchParams, removeParams } = useQueryParams();
  const { rule_id } = searchParams;
  const [createConversionRule, { isLoading: findLoading }] = useCreateConversionRuleMutation();
  const [updateConversionRule, { isLoading: updateLoading }] = useUpdateConversionRuleMutation();
  const [findConversionRule, { isLoading, data }] = ninjaApi.useLazyFindConversionRuleQuery();

  useEffect(() => {
    if (rule_id) {
      findConversionRule({ id: rule_id }).unwrap();
    }
  }, [rule_id]);

  const onUpdate = ({ config }) => {
    updateConversionRule({ config })
      .unwrap()
      .then(() => {
        snackbar.success('Conversion Successfully Update');
        removeParams(['rule_id', 'create_conv_pb_rule']);
      });
  };

  const handleConversionRule = ({ config }) => {
    createConversionRule({ config: config })
      .unwrap()
      .then(() => {
        snackbar.success('Conversion Successfully Created');
        removeParams(['rule_id', 'create_conv_pb_rule']);
      });
  };

  const validationSchema = yup.object({
    network_conversion_ids: yup
      .array()
      .min(1, 'Conversion is required')
      .required('Conversion is required'),
  });

  return (
    <AutomaticDrawer
      size='small'
      title='Conversion Rules'
      onClose={() => removeParams(['rule_id', 'create_conv_pb_rule'])}
      {...props}
    >
      <ConversionRuleForm
        data={data?.data}
        loading={isLoading || findLoading || updateLoading}
        ButtonText={rule_id ? 'Update' : 'Create'}
        handleConversionRule={rule_id ? onUpdate : handleConversionRule}
        rule_id={rule_id}
        validationSchema={validationSchema}
        initialValues={{
          object_type: 'Postback',
          id: data?.id || null,
        }}
      />
    </AutomaticDrawer>
  );
};

PostbacksConversionRulesDrawer.requiredParams = {
  create_conv_pb_rule: true,
};

export default PostbacksConversionRulesDrawer;
